export default __webpack_public_path__ + "static/media/uh_logo_white.42bae642.png";